import { render } from "./RPPEdit.vue?vue&type=template&id=d205c53e&scoped=true&ts=true"
import script from "./RPPEdit.vue?vue&type=script&lang=ts"
export * from "./RPPEdit.vue?vue&type=script&lang=ts"

import "./RPPEdit.vue?vue&type=style&index=0&id=d205c53e&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d205c53e"]])

export default __exports__